export const translations = {
  en: {
    // nav
    nav_home: "Home", nav_vip: "VIP", nav_brokers: "Brokers", nav_education: "Education",
    nav_results: "Results", nav_about: "About", nav_offers: "Offers", nav_faq: "FAQ",
    nav_contact: "Contact", nav_login: "Login", nav_signup: "Sign Up", nav_dashboard: "Dashboard",
    nav_admin: "Admin", nav_logout: "Logout",
    // hero
    hero_title: "INVIXA TRADERS",
    hero_subtitle: "Your Complete Trading Ecosystem",
    hero_desc: "Trading education, market insights, VIP membership, verified broker partnerships, performance reports, and a growing trading community — connected through INVIXA.",
    hero_cta_vip: "Join INVIXA VIP",
    hero_cta_broker: "Open Trading Account",
    // sections
    why_invixa: "Why INVIXA", services: "Services & Ecosystem",
    vip_section: "VIP Membership", partner_brokers: "Partner Brokers",
    education_preview: "Education", results_preview: "Performance & Results",
    testimonials: "Trader Stories", community: "Join the Community",
    faq: "Frequently Asked Questions", learn_more: "Learn More", view_all: "View All",
    get_started: "Get Started", read_more: "Read More",
    // risk
    risk_title: "Risk Disclaimer",
    risk_text: "Trading involves substantial risk and may not be suitable for everyone. Past performance does not guarantee future results. INVIXA provides education and information only — not financial advice.",
    past_performance: "Past performance does not guarantee future results.",
    // footer
    footer_tagline: "A premium trading ecosystem for education, insights and community.",
    footer_company: "Company", footer_legal: "Legal", footer_platform: "Platform",
    privacy: "Privacy Policy", terms: "Terms & Conditions", risk_disclosure: "Risk Disclosure",
    disclaimer: "Disclaimer", rights: "All rights reserved.",
    // common
    loading: "Loading...", no_content: "No content available yet.", coming_soon: "Coming soon.",
    email: "Email", password: "Password", name: "Full Name", submit: "Submit", save: "Save",
    cancel: "Cancel", search: "Search", status: "Status", date: "Date", actions: "Actions",
    // auth
    login_title: "Welcome back", signup_title: "Create your account",
    login_google: "Continue with Google", forgot_password: "Forgot password?",
    reset_password: "Reset Password", no_account: "Don't have an account?",
    have_account: "Already have an account?", referral_optional: "Referral code (optional)",
    // dashboard
    my_dashboard: "My Dashboard", profile: "Profile", vip_status: "VIP Status",
    broker_verification: "Broker Verification", referrals: "Referrals", support: "Support",
    telegram_access: "Telegram VIP Access", account: "Account",
    // home — why / ecosystem
    why_title: "Everything a trader needs, connected",
    why_subtitle: "Education, insights, VIP access, broker partnerships and transparency — in one premium platform.",
    svc_edu_title: "Trading Education",
    svc_edu_desc: "Structured lessons, guides and webinars for every level of trader.",
    svc_vip_title: "INVIXA VIP",
    svc_vip_desc: "Private Telegram community access, member benefits and priority content.",
    svc_brokers_title: "Partner Brokers",
    svc_brokers_desc: "Open accounts with verified partner brokers and unlock member benefits.",
    svc_perf_title: "Performance & Transparency",
    svc_perf_desc: "Transparent weekly and monthly result reports — clarity, not signals.",
    // home — vip band
    vip_band_title: "Unlock the INVIXA VIP experience",
    vip_band_desc: "Membership grants access to our private Telegram VIP community — through a monthly subscription, a verified partner-broker benefit, or a valid promo code.",
    vip_item_monthly: "Monthly", vip_item_monthly_desc: "Flexible subscription",
    vip_item_broker: "Broker Account Benefit", vip_item_broker_desc: "Verified partner account benefits",
    vip_item_promo: "Promo Codes", vip_item_promo_desc: "Discounts & free access",
    vip_item_telegram: "Telegram VIP", vip_item_telegram_desc: "Private community",
    // home — education / results / community
    edu_home_title: "Learn to trade with structure",
    edu_empty: "Educational content is on the way — check back soon.",
    results_home_title: "Transparent performance reports",
    results_empty: "Performance reports will appear here once published.",
    min_read: "min read",
    testimonials_title: "Trusted by our community",
    community_desc: "Create your free account to access the member dashboard, broker verification, referrals and VIP.",
    badge_secure: "Secure & private", badge_vip_tg: "Private VIP Telegram",
    theme: "Theme", theme_system: "System", theme_light: "Light", theme_dark: "Dark",
    vip_not_member: "Not a VIP member yet", vip_active_label: "VIP Active",
    vip_lifetime_access: "Lifetime access", vip_join_telegram: "Join Telegram VIP",
    vip_base_price: "Base monthly price", vip_per_month: "/ month",
    vip_promo_label: "Promo / Referral Code", vip_promo_placeholder: "Enter code", vip_apply: "Apply",
    vip_promo_not_combinable: "This promo cannot be combined with your broker benefit.",
    vip_broker_unlocked: "Broker Benefit Unlocked", vip_broker_pending: "Broker verification pending",
    vip_broker_pending_desc: "We're reviewing your broker account. Your benefit unlocks once approved.",
    vip_open_account_get: "OPEN A TRADING ACCOUNT & GET", vip_broker_banner_sub: "Open an account with an eligible INVIXA partner broker and verify your account to unlock your VIP benefit.",
    vip_view_brokers: "View Partner Brokers",
    vip_quote_title: "VIP Membership", vip_base_row: "Base price", vip_broker_benefit_row: "Broker benefit",
    vip_promo_row: "Promo code", vip_your_price: "Your VIP Price", vip_free: "Free",
    vip_first_then: "for the first period, then", vip_request_join: "Request to Join INVIXA VIP",
    vip_update_request: "Update My VIP Request", vip_pending_note: "Your VIP request is pending review. You can still update it below and we'll use the latest quote.",
    vip_payment_note: "Online payment is not enabled yet — all VIP activations are reviewed and approved by our team.",
    vip_applied_benefit: "Applied benefit", vip_free_until: "Free until", vip_expires: "Expires",
  },
  ar: {
    nav_home: "الرئيسية", nav_vip: "كبار الأعضاء", nav_brokers: "الوسطاء", nav_education: "التعليم",
    nav_results: "النتائج", nav_about: "من نحن", nav_offers: "العروض", nav_faq: "الأسئلة",
    nav_contact: "اتصل بنا", nav_login: "دخول", nav_signup: "إنشاء حساب", nav_dashboard: "لوحتي",
    nav_admin: "الإدارة", nav_logout: "خروج",
    hero_title: "INVIXA TRADERS",
    hero_subtitle: "منظومتك الكاملة للتداول",
    hero_desc: "تعليم التداول، رؤى الأسواق، عضوية كبار الأعضاء، شراكات وسطاء موثوقة، تقارير الأداء، ومجتمع تداول متنامٍ — كل ذلك عبر INVIXA.",
    hero_cta_vip: "انضم إلى VIP",
    hero_cta_broker: "افتح حساب تداول",
    why_invixa: "لماذا INVIXA", services: "الخدمات والمنظومة",
    vip_section: "عضوية كبار الأعضاء", partner_brokers: "الوسطاء الشركاء",
    education_preview: "التعليم", results_preview: "الأداء والنتائج",
    testimonials: "قصص المتداولين", community: "انضم إلى المجتمع",
    faq: "الأسئلة الشائعة", learn_more: "اعرف المزيد", view_all: "عرض الكل",
    get_started: "ابدأ الآن", read_more: "اقرأ المزيد",
    risk_title: "إخلاء المسؤولية عن المخاطر",
    risk_text: "ينطوي التداول على مخاطر كبيرة وقد لا يكون مناسبًا للجميع. الأداء السابق لا يضمن النتائج المستقبلية. توفر INVIXA التعليم والمعلومات فقط — وليست نصيحة مالية.",
    past_performance: "الأداء السابق لا يضمن النتائج المستقبلية.",
    footer_tagline: "منظومة تداول متميزة للتعليم والرؤى والمجتمع.",
    footer_company: "الشركة", footer_legal: "قانوني", footer_platform: "المنصة",
    privacy: "سياسة الخصوصية", terms: "الشروط والأحكام", risk_disclosure: "الإفصاح عن المخاطر",
    disclaimer: "إخلاء المسؤولية", rights: "جميع الحقوق محفوظة.",
    loading: "جارٍ التحميل...", no_content: "لا يوجد محتوى بعد.", coming_soon: "قريبًا.",
    email: "البريد الإلكتروني", password: "كلمة المرور", name: "الاسم الكامل", submit: "إرسال",
    save: "حفظ", cancel: "إلغاء", search: "بحث", status: "الحالة", date: "التاريخ", actions: "إجراءات",
    login_title: "مرحبًا بعودتك", signup_title: "أنشئ حسابك",
    login_google: "المتابعة عبر جوجل", forgot_password: "نسيت كلمة المرور؟",
    reset_password: "إعادة تعيين كلمة المرور", no_account: "ليس لديك حساب؟",
    have_account: "لديك حساب بالفعل؟", referral_optional: "رمز الإحالة (اختياري)",
    my_dashboard: "لوحتي", profile: "الملف الشخصي", vip_status: "حالة VIP",
    broker_verification: "توثيق الوسيط", referrals: "الإحالات", support: "الدعم",
    telegram_access: "دخول تيليجرام VIP", account: "الحساب",
    why_title: "كل ما يحتاجه المتداول، في مكان واحد",
    why_subtitle: "تعليم، ورؤى، وعضوية VIP، وشراكات وسطاء، وشفافية — ضمن منصة واحدة متميزة.",
    svc_edu_title: "تعليم التداول",
    svc_edu_desc: "دروس منظمة وأدلة وندوات لكل مستويات المتداولين.",
    svc_vip_title: "INVIXA VIP",
    svc_vip_desc: "دخول مجتمع تيليجرام الخاص، ومزايا الأعضاء، ومحتوى ذو أولوية.",
    svc_brokers_title: "الوسطاء الشركاء",
    svc_brokers_desc: "افتح حسابات مع وسطاء شركاء موثوقين واحصل على مزايا الأعضاء.",
    svc_perf_title: "الأداء والشفافية",
    svc_perf_desc: "تقارير نتائج أسبوعية وشهرية شفافة — وضوح، وليست إشارات.",
    vip_band_title: "افتح تجربة INVIXA VIP",
    vip_band_desc: "تمنحك العضوية الدخول إلى مجتمع تيليجرام VIP الخاص — عبر اشتراك شهري، أو مزية وسيط شريك موثوق، أو رمز ترويجي صالح.",
    vip_item_monthly: "شهري", vip_item_monthly_desc: "اشتراك مرن",
    vip_item_broker: "مزية حساب الوسيط", vip_item_broker_desc: "مزايا حساب الشريك الموثوق",
    vip_item_promo: "الرموز الترويجية", vip_item_promo_desc: "خصومات ودخول مجاني",
    vip_item_telegram: "تيليجرام VIP", vip_item_telegram_desc: "مجتمع خاص",
    edu_home_title: "تعلّم التداول بمنهجية",
    edu_empty: "المحتوى التعليمي في الطريق — عد قريبًا.",
    results_home_title: "تقارير أداء شفافة",
    results_empty: "ستظهر تقارير الأداء هنا بمجرد نشرها.",
    min_read: "دقيقة قراءة",
    testimonials_title: "موثوق من مجتمعنا",
    community_desc: "أنشئ حسابك المجاني للوصول إلى لوحة الأعضاء وتوثيق الوسيط والإحالات وعضوية VIP.",
    badge_secure: "آمن وخاص", badge_vip_tg: "تيليجرام VIP خاص",
    theme: "المظهر", theme_system: "النظام", theme_light: "فاتح", theme_dark: "داكن",
    vip_not_member: "لست عضو VIP بعد", vip_active_label: "عضوية VIP فعّالة",
    vip_lifetime_access: "دخول مدى الحياة", vip_join_telegram: "انضم إلى تيليجرام VIP",
    vip_base_price: "السعر الشهري الأساسي", vip_per_month: "/ شهريًا",
    vip_promo_label: "رمز ترويجي / إحالة", vip_promo_placeholder: "أدخل الرمز", vip_apply: "تطبيق",
    vip_promo_not_combinable: "لا يمكن دمج هذا الرمز مع مزية الوسيط الخاصة بك.",
    vip_broker_unlocked: "تم فتح مزية الوسيط", vip_broker_pending: "توثيق الوسيط قيد المراجعة",
    vip_broker_pending_desc: "نراجع حساب الوسيط الخاص بك. ستُفتح مزيتك بعد الموافقة.",
    vip_open_account_get: "افتح حساب تداول واحصل على", vip_broker_banner_sub: "افتح حسابًا مع وسيط شريك مؤهل لدى INVIXA ووثّق حسابك لفتح مزية VIP الخاصة بك.",
    vip_view_brokers: "عرض الوسطاء الشركاء",
    vip_quote_title: "عضوية VIP", vip_base_row: "السعر الأساسي", vip_broker_benefit_row: "مزية الوسيط",
    vip_promo_row: "الرمز الترويجي", vip_your_price: "سعر VIP الخاص بك", vip_free: "مجاني",
    vip_first_then: "للفترة الأولى، ثم", vip_request_join: "اطلب الانضمام إلى INVIXA VIP",
    vip_update_request: "تحديث طلب VIP الخاص بي", vip_pending_note: "طلب VIP الخاص بك قيد المراجعة. يمكنك تحديثه أدناه وسنستخدم أحدث عرض سعر.",
    vip_payment_note: "الدفع الإلكتروني غير مُفعّل بعد — تتم مراجعة جميع تفعيلات VIP والموافقة عليها من فريقنا.",
    vip_applied_benefit: "المزية المطبقة", vip_free_until: "مجاني حتى", vip_expires: "ينتهي في",
  },
};
